<template>
	<section>
		<v-layout class="rol-section my-4 px-5">
			<v-flex xs12 md3 mr-5>
				<v-select
				solo
				hide-details
				return-object
				label="Roles"
				item-text="name"
				:items="roles"
				@input="getData($event, 'rolSelected', 'codeRole', 'apps')"
				></v-select>
			</v-flex>
			<v-flex xs12 md3>
				<v-btn
					color="white"
					@click="newRol"
					>
					Crear rol
					<v-icon>add</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>
		<transition name="fade-down" mode="out-in">
			<div v-if="appsExist">
				<v-divider class="my-3"></v-divider>
				<v-layout class="px-5">
					<v-flex xs12>
						<h3>Aplicaciones</h3>
						<div class="responsive-grid">
							<app-button
								v-for="(app, indexApp) in apps"
								:key="indexApp"
								:class="[
									{ 'configured-app-class': app.isSelected },
									{ 'active-app-class': app.isActive },
								]"
								:icons-to-use="appUseIcon(app)"
								:item="app"
								@erase-configuration="deleteConfiguration('appIds', $event)"
								@button-clicked="getData($event, 'app', 'codeApp', 'modules')"
							/>
						</div>
					</v-flex>
				</v-layout>
			</div>
		</transition>
		<transition name="fade-down" mode="out-in">
			<v-layout class="module-section pb-70 mt-3 pt-2 px-5" v-if="modulesExist">
				<v-flex xs12>
					<h3>{{getAppName}}: Módulos</h3>
					<div class="responsive-grid">
						<app-button
							v-for="(mod, indexMod) in modules"
							:key="indexMod"
							:class="[
								{ 'configured-module-class': configured(mod) },
								{ 'active-module-class': mod.isActive },
							]"
							:icons-to-use="moduleUseIcon(mod)"
							:item="mod"
							@erase-configuration="deleteConfiguration('moduleIds', $event)"
							@button-clicked="getData($event, 'module', 'idModule', 'resources')"
							@edit-button="openModuleAndResourceConfiguration('module', $event)"
						/>
					</div>
				</v-flex>
			</v-layout>
		</transition>
		<transition name="fade-down" mode="out-in">
			<div v-if="resourcesExist">
				<v-divider class="my-3"></v-divider>
				<v-layout class="px-5 pb-70">
					<v-flex xs12>
						<h3>{{getAppName}} - {{getModuleName}}</h3>
						<div class="px-5">
							<app-table
								selectable
								class="mt-1 is-not-selectable"
								name="resources"
								:columns="columns"
								:rows="resourcesComputed"
								@row-is-selected="resourceSelectAction"
							>
								<template slot="rows" slot-scope="props">
									<td>
										{{ props.row.name }}
									</td>
									<td>
										{{ props.row.uri }}
									</td>
									<td>
										{{ getResourceName(props.row) }}
									</td>
									<td class="px-2 py-2">
										<v-text-field
											solo
											v-if="props.row.templateLanguages"
											hide-details
											v-model="props.row.templateLanguages.position"
										/>
									</td>
									<td>
										<app-tooltip-button
											color="green"
											icon="settings"
											text="Conf. de Recursos"
											@click-icon="openModuleAndResourceConfiguration(
												'resource',
												props.row,
											)"
										/>
										<app-tooltip-button
											:disabled="props.row.disabled"
											color="blue"
											icon="timeline"
											text="Barra de acciones"
											@click-icon="openActionsBarModal(props.row)"
										/>
										<button 
											@click="loadServices(props.row)"
											:disabled="props.row.disabled">
											<img 
												src="https://s3.amazonaws.com/apprunn-acl/icons/53v0AJ79clj62cA8zvhzycXgHFrfdT.png" 
												alt="WS"
												height="20">
										</button>
									</td>
								</template>
							</app-table>
						</div>
					</v-flex>
				</v-layout>
			</div>
		</transition>
		<action-sidebar
			:title="action.title"
			:value="action.open"
			:is-selected="action.IsSelected"
			@close-modal="clearTemporalSelected"
		>
			<bar-actions
				v-if="action.code === 'bar-actions'"
				:actions="actions"
				@close-modal="clearTemporalSelected"
				@save-data="saveBarActionData"
				@select-all="selectAll"
				@row-is-selected="rowIsSelected"
			/>
			<new-rol-component
				v-if="action.code === 'rol'"
				@close-modal="closeRolModal"
			/>
			<resource-configuration
				v-if="chooseAction"
				:resource="chooseResource"
				@set-image="setImageResource"
				@close-modal="defaultAction"
				@save-data="saveData"
			/>
			<resource-web-service
				v-if="action.code === 'list-service'"
				:web-services="webServices"
				:check-all="checkAllServices"
				@close="clearTemporalSelected"
				@select-all="selectAllServices"
				@save-web-service="saveWebServices"
				@row-is-selected="rowIsSelectedServices"
			/>
		</action-sidebar>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="false"
				@accept-button-clicked="saveInfo(model)"
				@cancel-button-clicked="cancelAction"/>
		</section>
	</section>
</template>
<script>
import appButton from '@/components/shared/app-button';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import actionSidebar from '@/components/shared/action-sidebar';
import resourceConfiguration from '@/components/resources/resource-configuration';
import newRolComponent from '@/components/roles/new-rol-component';
import barActions from '@/components/actions/actions-bar';
import resourceWebService from '@/components/resource-service/resource-web-service';
import lib from '@/lib';

const {
	compose,
	createPropertyByOtherOne,
	equality,
	find,
	getDeeper,
	removeItemFromArray,
	setNewProperty,
	setNewPropertyByFunction,
	updateItemInCollection,
} = lib;

function created() {
	({ codeProject: this.codeProject, idTemplate: this.idTemplate } = this.$route.params);
	this.loadResources('roles');
	this.loadLanguages();
}

async function loadResources(flag, action = null) {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const url = `/project/${this.codeProject}/template/${this.idTemplate}/${flag}`;
	const { data: response } = await this.$http.get(url, { headers, params: this.params });
	({ data: this[flag] } = response);
	if (flag === 'resources') {
		this.updateResources();
	} else if (flag === 'actions') {
		if (this.temporalSelected.length > 0 && this.model.roleIds) {
			this.actions = this.actions.map((a) => {
				const newRow = { ...a };
				const newFlag = this.model.roleIds[0].resources.filter(r => r.id === action.id);
				const flagIndex = newFlag.length && newFlag[0].actions ?
					newFlag[0].actions.findIndex(f => f === a.id) : -1;
				newRow.isSelected = flagIndex > -1 || a.isSelected;
				return newRow;
			});
		}
		this.dataSelected = this.actions.filter(a => a.isSelected);
	}
}

function evaluateTemplateLanguages(item) {
	const exist = getDeeper('templateLanguages')(item);
	return !exist;
}

function updateResources() {
	this.resources = this.resources.map(
		setNewPropertyByFunction('disabled', this.evaluateTemplateLanguages, false),
	);
}

async function loadLanguages() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		const { data: project } = await this.$http.get(`projects/${this.codeProject}`, { headers });
		const projectLanguages = project.data.languages;
		const self = this;
		Object.keys(projectLanguages).forEach((pLangKey) => {
			const currentLanguage = projectLanguages[pLangKey];
			self.languages = self.languages.concat(currentLanguage);
		});
	} catch (err) {
		this.showError();
	}
}

function getData(obj, vueVariable, flagParam, flag) {
	this.setDefaultValues(flagParam);
	this[vueVariable] = { ...obj };
	this.updateIsActiveProperty(flagParam, obj);
	if (flag === 'resources' && (!obj.flagStatus && !obj.isSelected && !obj.flagActions)) {
		this[flag] = [];
	} else {
		this.params[flagParam] = flag === 'resources' ? obj.id : obj.code || obj[flagParam] || obj.id;
		this.loadResources(flag, obj);
	}
}

function updateIsActiveProperty(flagParam, obj) {
	const opt = {
		codeApp: 'apps',
		idModule: 'modules',
	};
	const varSelected = opt[flagParam];
	if (varSelected) {
		this[varSelected] = this[varSelected].reduce((list, item) => {
			const newItem = { ...item };
			newItem.isActive = false;
			if (obj.id === item.id) {
				newItem.isActive = true;
			}
			return list.concat(newItem);
		}, []);
	}
}

function setDefaultValues(flag) {
	const opt = {
		codeRole: this.clearData,
		codeApp: this.clearIdModuleAnResources,
	};
	if (opt[flag]) {
		opt[flag].call();
	}
}

function clearIdModuleAnResources() {
	this.actions = [];
	this.barActionSelected = {};
	this.module = {};
	this.modules = [];
	this.params.idModule = null;
	this.resource = null;
	this.resources = [];
}

function clearData() {
	this.actions = [];
	this.app = {};
	this.apps = [];
	this.barActionSelected = {};
	this.module = {};
	this.modules = [];
	this.resource = null;
	this.resources = [];
	this.params = {
		codeApp: null,
		codeRole: null,
		idModule: null,
		idResource: null,
		page: null,
		perPage: null,
	};
}

function getAppName() {
	return getDeeper('name')(this.app);
}

function getModuleName() {
	return getDeeper('name')(this.module);
}

function getResourceName({ resourceId }) {
	const { name } = (find(equality('id', resourceId), this.resources) || {});
	return name || '--';
}

function resourcesExist() {
	return this.resources.length > 0;
}

function modulesExist() {
	return this.modules.length > 0;
}

function appsExist() {
	return this.apps.length > 0;
}

function openModuleAndResourceConfiguration(flag, reso) {
	this.updateCurrentModuleOrResource(flag, reso);
	if (flag !== 'list-service') {
		const opt = {
			module: this.actionModule,
			resource: this.actionResource,
		};
		this.action = { ...opt[flag] };
	}
}

function defaultAction() {
	this.action = {
		code: null,
		open: false,
		title: '',
		templateLanguagesArray: [],
	};
}

function clearTemporalSelected() {
	this.action = {
		code: null,
		open: false,
		title: '',
	};
	if (this.dataSelected.length > 0) {
		this.dataSelected = [];
	}
}

function updateCurrentModuleOrResource(flag, reso) {
	const { templateLanguages } = reso;
	let newFlag = flag;
	if (flag === 'list-service') {
		newFlag = 'resource';
	}
	if (templateLanguages) {
		const languages = this.getLanguages(templateLanguages);
		this[newFlag] = setNewProperty('templateLanguagesArray', languages)(reso);
	} else {
		const languages = this.languages.map(setNewProperty('name', ''));
		this[newFlag] = setNewProperty('templateLanguagesArray', languages)(reso);
	}
}

function getLanguages({ languages }) {
	return Object.keys(languages).map(lan => languages[lan]);
}

function setImageResource(img) {
	this.resource.pathIcon = img;
}

function newRol() {
	this.action = { ...this.actionNewRol };
}

function openActionsBarModal(action) {
	this.actions = [];
	this.resource = { ...action };
	this.getData(action, 'resource', 'idResource', 'actions');
	this.action = { ...this.actionBarActions };
}

function appUseIcon(app) {
	return (app.isSelected || app.isActive) ? ['close'] : [];
}

function moduleUseIcon(mod) {
	return (mod.isSelected || mod.isActive || mod.flagStatus || mod.flagActions) ? ['edit', 'close'] : ['edit'];
}

function chooseAction() {
	return this.action.code === 'module' || this.action.code === 'resource';
}

function chooseResource() {
	let returnedObj = {};
	if (this.action.code === 'module') {
		returnedObj = { ...this.module };
	} else if (this.action.code === 'resource') {
		returnedObj = { ...this.resource };
	}
	return returnedObj;
}

function updateRoleIdsInfo(resource) {
	const newResource = compose(
		setNewProperty('flagActions', true),
		setNewProperty('flagStatus', true),
		setNewProperty('isSelected', true),
	)(resource);
	this.updateRoleAndResources(newResource);
	this.resources = updateItemInCollection('id', newResource, this.resources);
}

function configured(mod) {
	return mod.isSelected || mod.flagStatus || mod.flagActions;
}

function cancelAction() {
	this.$router.go(-1);
}

async function saveInfo(body, flagDelete, vueArray) {
	const newBody = { ...body };
	if (newBody.resourceIds) {
		newBody.resourceIds = body.resourceIds.map((resource) => {
			const newResource = { ...resource };
			const keys = Object.keys(resource.languages);
			newResource.languages = keys.reduce((acum, k) => {
				const newAcum = { ...acum };
				const newKey = k.toLowerCase();
				newAcum[newKey] = resource.languages[k];
				return newAcum;
			}, {});
			return newResource;
		});
	}
	if (newBody.roleIds) {
		newBody.roleIds = newBody.roleIds.map((roleId) => {
			const newRoleId = { ...roleId };
			newRoleId.typeRoleId = this.rolSelected.typeRoleId;
			return newRoleId;
		});
	}
	const url = `distribution-template/${this.idTemplate}`;
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		await this.$http.patch(url, newBody, { headers });
		this.showNotification('Actualización exitosa');
		if (vueArray) {
			this.loadResources(vueArray);
		}
	} catch (error) {
		this.showError('Los cambios no se guardaron', 'info');
	}
	if (!flagDelete) {
		this.model = {};
	}
}

function closeRolModal({ reCharge }) {
	this.defaultAction();
	if (reCharge) {
		this.loadResources('roles');
	}
}

function selectAll(value) {
	this.actions = this.actions.map(setNewProperty('isSelected', value));
}

function rowIsSelected(row) {
	if (row.isSelected) {
		this.dataSelected.push(row);
	} else {
		const index = this.dataSelected.findIndex(r => r.id === row.id);
		this.dataSelected.splice(index, 1);
	}
}

function getActionsSelected(actions) {
	return actions.reduce((list, item) => {
		if (item.isSelected) {
			return list.concat(item.id);
		}
		return list;
	}, []);
}

function deleteConfiguration(flag, item) {
	const opt = {
		appIds: [compose(
			setNewProperty('flagStatus', true),
			setNewProperty('flagActions', false),
			setNewProperty('isSelected', false),
			setNewProperty('flagDelete', true),
		), 'apps'],
		moduleIds: [this.deleteModuleConfiguration, 'modules'],
	};
	const body = {};
	body[flag] = [opt[flag][0].call(null, item)];
	const vueArray = opt[flag][1];
	this.saveInfo(body, 'delete', vueArray);
}

function deleteModuleConfiguration(item) {
	const { templateLanguages } = item;
	const { languages } = templateLanguages;
	return compose(
		setNewProperty('flagStatus', false),
		setNewProperty('isSelected', false),
		setNewProperty('flagActions', false),
		setNewProperty('flagDelete', true),
		setNewProperty('languages', languages),
		setNewProperty('codeRole', this.rolSelected.code),
	)(item);
}

function createTemplateLanguages(flag) {
	this[flag].templateLanguages = { languages: {} };
	this[flag].templateLanguagesArray.forEach((lan) => {
		this[flag].templateLanguages.languages[lan.id] = lan;
	});
}

function saveData(resource, newPosition) {
	const flag = this.action.code;
	this.createTemplateLanguages(flag);
	const languages = { ...this[flag].templateLanguages.languages };
	const newLanguages = {};
	newLanguages.es = languages.Es || languages.es;
	newLanguages.en = languages.En || languages.en;
	this[flag] = compose(
		setNewProperty('disabled', false),
		setNewProperty('flagStatus', true),
		setNewProperty('flagActions', true),
		setNewProperty('flagDelete', false),
		setNewProperty('languages', newLanguages),
		setNewProperty('codeRole', this.rolSelected.code),
	)(this[flag]);
	const keys = {
		resource: 'resourceIds',
		module: 'moduleIds',
	};
	if (getDeeper(keys[flag])(this.model)) {
		this.model[keys[flag]] = this.model[keys[flag]].concat(this[flag]);
	} else {
		this.model[keys[flag]] = [].concat(this[flag]);
	}
	if (flag === 'resource') {
		this.updateRoleIdsInfo(this[flag]);
		const index = this.resources.findIndex(r => r.id === resource.id);
		this.resources[index].templateLanguages.position = Number(newPosition ||
		resource.templateLanguages.position);
		this[flag].position = Number(newPosition || resource.templateLanguages.position);
		this.resources[index].position = Number(newPosition || resource.templateLanguages.position);
	} else {
		const indexMo = this.modules.findIndex(r => r.id === resource.id);
		this.modules[indexMo].position = Number(newPosition ||
		resource.templateLanguages.position);
		this[flag].position = Number(newPosition ||
		resource.templateLanguages.position);
		const array = `${flag}s`;
		this[array] = updateItemInCollection('id', this[flag], this[array]);
	}
	this.defaultAction();
}

function modelEmpty() {
	return Object.keys(this.model).length === 0;
}

function inverseValue(prop) {
	return function inner(item) {
		return !item[prop];
	};
}

function resourceSelectAction(resource) {
	const newResource = compose(
		setNewPropertyByFunction('flagDelete', this.inverseValue('isSelected')),
		setNewProperty('flagStatus', true),
		setNewProperty('flagActions', true),
	)(resource);
	this.updateRoleAndResources(newResource);
}

function updateRoleAndResources(newResource) {
	if (getDeeper('roleIds')(this.model)) {
		const { code } = this.rolSelected;
		const index = this.model.roleIds.findIndex(role => role.code === code);
		if (index > -1) {
			const resume = this.model.roleIds[index].resources;
			const { id: resourceId } = newResource;
			const i = this.model.roleIds[index].resources.findIndex(re => re.id === resourceId);
			if (i > -1) {
				this.model.roleIds[index].resources = removeItemFromArray('id', resourceId)(resume);
			} else {
				this.model.roleIds[index].resources = resume.concat(newResource);
			}
		} else {
			const roleSelected = setNewProperty('resources', [newResource])(this.rolSelected);
			this.model.roleIds = this.model.roleIds.concat([roleSelected]);
		}
	} else {
		const roleSelected = this.setNewRole([newResource]);
		this.model.roleIds = [].concat([roleSelected]);
	}
}

function resourcesComputed() {
	return this.resources;
}

function saveBarActionData() {
	this.dataSelected.forEach((row) => {
		this.temporalSelected.push(row);
		this.actions = updateItemInCollection('id', row, this.actions);
		const actions = this.getActionsSelected(this.actions);
		const { code } = this.rolSelected;
		const { id, name } = this.resource;
		const resources = [{ actions, flagStatus: true, flagActions: true, id, name, permission: [] }];
		if (this.model.roleIds) {
			const indexRol = this.model.roleIds.findIndex(equality('code', code));
			if (indexRol > -1) {
				const index = this.model.roleIds[indexRol].resources.findIndex(equality('id', id));
				if (index > -1) {
					this.model.roleIds[indexRol].resources[index].actions = [...actions];
				} else {
					this.model.roleIds[indexRol].resources
						= this.model.roleIds[indexRol].resources.concat(resources);
				}
			} else {
				const newRole = this.setNewRole(resources);
				this.model.roleIds = this.model.roleIds.concat(newRole);
			}
		} else {
			const newRole = this.setNewRole(resources);
			this.model.roleIds = [].concat(newRole);
		}
	});
	const actions = this.getActionsSelected(this.actions);
	const { code } = this.rolSelected;
	const { id, name, templateLanguages } = this.resource;
	const resources = [{ actions, flagStatus: true, flagActions: true, id, name, permission: [] }];
	this.checkForRoleIds(id, code, resources, actions);
	this.checkForResourceIds(id, templateLanguages);
	this.defaultAction();
	this.dataSelected = [];
}

function checkForResourceIds(id, templateLanguages) {
	const { languages } = templateLanguages;
	const newResource = compose(
		setNewProperty('languages', languages),
		setNewProperty('flagStatus', true),
		setNewProperty('flagActions', true),
		createPropertyByOtherOne('id_module', 'moduleId'),
	)(this.resource);
	if (this.model.resourceIds) {
		const indexResource = this.model.resourceIds.findIndex(equality('id', id));
		if (indexResource > -1) {
			this.model.resourceIds[indexResource] = { ...newResource };
		} else {
			this.model.resourceIds = this.model.resourceIds.concat({ ...newResource });
		}
	} else {
		this.model.resourceIds = [newResource];
	}
}

function checkForRoleIds(id, code, resources, actions) {
	if (this.model.roleIds) {
		const indexRol = this.model.roleIds.findIndex(equality('code', code));
		if (indexRol > -1) {
			const index = this.model.roleIds[indexRol].resources.findIndex(equality('id', id));
			if (index > -1) {
				this.model.roleIds[indexRol].resources[index].actions = [...actions];
			} else {
				this.model.roleIds[indexRol].resources
					= this.model.roleIds[indexRol].resources.concat(resources);
			}
		} else {
			const newRole = this.setNewRole(resources);
			this.model.roleIds = this.model.roleIds.concat(newRole);
		}
	} else {
		const newRole = this.setNewRole(resources);
		this.model.roleIds = [].concat(newRole);
	}
}

function setNewRole(resources) {
	return compose(
		setNewProperty('flagStatus', true),
		setNewProperty('resources', resources),
		createPropertyByOtherOne('nameRole', 'name'),
		createPropertyByOtherOne('codeRole', 'code'),
	)(this.rolSelected);
}

async function loadServices(row) {
	this.openModuleAndResourceConfiguration('list-service', row);
	try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const params = {
			codeApp: this.app.codeApp,
			codeRole: this.rolSelected.code,
			idModule: row.moduleId,
			idResource: row.id,
		};
		const url = `/project/${this.codeProject}/template/${this.idTemplate}/web-services`;
		const { data: response } = await this.$http.get(url, { headers, params });
		if (this.resource.permission) {
			const exitServices = Object.keys(this.resource.permission);
			this.webServices = response.data.map((d) => {
				const newService = { ...d };
				const index = exitServices.findIndex(s => Number(s) === d.id);
				newService.isSelected = index > -1;
				newService.authorize = index > -1 ? this.resource.permission[d.id] : d.authorize;
				return newService;
			});
		} else {
			this.webServices = response.data;
		}
		this.action = { ...this.actionListService };
		this.action.title = row.name;
	} catch (error) {
		this.showError();
	}
}

function saveWebServices(rows) {
	const selectRows = rows.filter(r => r.isSelected);
	let permission = {};
	if (selectRows.length) {
		permission = selectRows.reduce((acum, item) => {
			const newAcum = { ...acum };
			newAcum[item.id] = item.authorize;
			return newAcum;
		}, {});
	}
	this.defaultAction();
	this.resource.permission = { ...permission };
	this.resource.flagPermission = true;
	this.resource.flagStatus = true;
	this.action.code = 'resource';
	this.saveData(this.resource, this.resource.position);
}

function selectAllServices(value) {
	this.checkAllServices = value;
	this.webServices = this.webServices.map(setNewProperty('isSelected', value));
}

function rowIsSelectedServices(row) {
	this.webServices = this.selectIsRow(this.webServices, 'isSelected', row);
	this.checkAllServices = this.webServices.every(s => s.isSelected);
}
function data() {
	return {
		action: {
			code: null,
			open: false,
			title: '',
		},
		actionNewRol: {
			code: 'rol',
			open: true,
			title: 'Nuevo rol',
		},
		actions: [],
		actionBarActions: {
			code: 'bar-actions',
			open: true,
			title: 'Asignar barra de acciones',
		},
		actionModule: {
			code: 'module',
			open: true,
			title: 'Configuración del módulo',
		},
		actionListService: {
			code: 'list-service',
			open: true,
			title: 'Nombre del recurso',
		},
		actionResource: {
			code: 'resource',
			open: true,
			title: 'Configuración de Recurso',
		},
		app: {},
		apps: [],
		codeProject: null,
		columns: [
			{ id: 1, name: 'Nombre del Recurso', checked: true, visible: true },
			{ id: 2, name: 'URL', checked: true, visible: true },
			{ id: 3, name: 'Recurso Padre', checked: true, visible: true },
			{ id: 4, name: 'Posición', checked: true, visible: true },
			{ id: 5, name: 'Acciones', checked: true, visible: true },
		],
		idTemplate: null,
		languages: [],
		model: {},
		module: {},
		modules: [],
		params: {
			codeApp: null,
			codeRole: null,
			idModule: null,
			idResource: null,
			page: null,
			perPage: null,
		},
		resource: {},
		resources: [],
		roles: [],
		rolSelected: {},
		temporalSelected: [],
		dataSelected: [],
		webServices: [],
		dataSelectdServices: [],
		changeResource: {},
		checkAllServices: false,
	};
}

export default {
	name: 'page-resources-assignment',
	components: {
		actionSidebar,
		appButton,
		appTooltipButton,
		barActions,
		newRolComponent,
		resourceConfiguration,
		resourceWebService,
	},
	computed: {
		appsExist,
		chooseAction,
		chooseResource,
		getAppName,
		getModuleName,
		modelEmpty,
		modulesExist,
		resourcesComputed,
		resourcesExist,
	},
	created,
	data,
	methods: {
		appUseIcon,
		cancelAction,
		clearData,
		clearIdModuleAnResources,
		clearTemporalSelected,
		closeRolModal,
		checkForResourceIds,
		checkForRoleIds,
		configured,
		createTemplateLanguages,
		defaultAction,
		deleteConfiguration,
		deleteModuleConfiguration,
		evaluateTemplateLanguages,
		getActionsSelected,
		inverseValue,
		loadLanguages,
		loadResources,
		loadServices,
		getData,
		getLanguages,
		getResourceName,
		newRol,
		openActionsBarModal,
		openModuleAndResourceConfiguration,
		moduleUseIcon,
		resourceSelectAction,
		rowIsSelected,
		saveBarActionData,
		saveData,
		saveInfo,
		selectAll,
		setDefaultValues,
		setImageResource,
		setNewRole,
		updateCurrentModuleOrResource,
		updateIsActiveProperty,
		updateResources,
		updateRoleAndResources,
		updateRoleIdsInfo,
		saveWebServices,
		selectAllServices,
		rowIsSelectedServices,
	},
};
</script>
<style lang="scss" scoped>
.items-arragnment {
	display: flex;
	flex-wrap: wrap;
}

.responsive-grid {
	display: grid;
	grid-gap: 8px;
	grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
}

.module-section {
	background-color: white;
}

.pb-70 {
	padding-bottom: 70px;
}

.fade-down-enter-active {
  transition: all .4s ease;
}

.fade-down-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.fade-down-enter, .fade-down-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.configured-app-class {
	border: 1px solid map-get($colors, base) !important;
}

.configured-module-class {
	border: 1px solid map-get($colors, green-icon) !important;
}

.active-app-class {
	background-color: map-get($colors, base) !important;
	color: white;
}
</style>


// WEBPACK FOOTER //
// src/pages/template/page-resources-assignment.vue